module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/schneider/schneider.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/schneider/schneider.png
// module id = 620
// module chunks = 0